import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey =
  | 'singleSelectFieldPlaceholderMessage'
  | 'multiSelectFieldPlaceholderMessage'
  | 'noResultMessage';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  singleSelectFieldPlaceholderMessage: {
    id: 'boxFileRequest.singleSelectField.placeholderMessage',
    description: 'Placeholder for single select field',
    defaultMessage: 'Select an option',
  },
  multiSelectFieldPlaceholderMessage: {
    id: 'boxFileRequest.multiSelectField.placeholderMessage',
    description: 'Placeholder for multi select field',
    defaultMessage: 'Select options',
  },
  noResultMessage: {
    id: 'boxFileRequest.selectField.noResultMessage',
    description: 'Message to display in combobox when no results found',
    defaultMessage: 'No results found',
  },
});

export default messages;
